$(document).ready(function () {

	var slideIndex = 1;
	showSlides(slideIndex);

	$("#mySlideShow .thumb").on("click", function () {
		var id = parseInt($(this).attr("id"));
		currentSlide(id);
	});

	$("#mySlideShow .prev").on("click", function (e) {
		e.preventDefault();
		plusSlides(-1);
	});

	$("#mySlideShow .next").on("click", function (e) {
		e.preventDefault();
		plusSlides(1);
	});

	function plusSlides(n) {
		showSlides(slideIndex += n);
	}

	function currentSlide(n) {
		showSlides(slideIndex = n);
	}

	function showSlides(n) {
		var slides = $("#mySlideShow .mySlides");
		var dots = $("#mySlideShow .column");

		if (!slides.length) return;

		if (n > slides.length) slideIndex = 1;
		if (n < 1) slideIndex = slides.length;

		slides.removeClass("active").hide();
		dots.removeClass("active");

		slides.eq(slideIndex - 1).addClass("active").show();
		dots.eq(slideIndex - 1).addClass("active");
	}

});